export type Reducer<T, U> = (accumulator: U, value: ReducerSteroids<T>, index: number, array: readonly T[]) => U;
export interface ReducerSteroids<T> {
  current: T;
  next: T;
  previous: T;
}

function reduceOnSteroids<T, U>(collection: readonly T[], reducer: Reducer<T, U>, initial: U): U {
  let value = initial;

  for (let index = 0; index < collection.length; index++) {
    const steroids = {
      current: collection[index],
      next: collection[index + 1],
      previous: collection[index - 1],
    };
    value = reducer(value, steroids, index, collection);
  }

  return value;
}

export {
  reduceOnSteroids,
};
